<template>
  <div class="d-flex align-start line-height-normal mb-2">
    <div class="position-relative">
      <v-icon :style="{ visibility: notif.seen_at ? 'hidden' : '' }" :title="$t('NOTIFICATIONS.MARK_AS_READ')" color="successgreen" size="9" style="position: absolute; top: -1px; left: -1px;"
              @click="seenNotification(notif)">
        fas fa-circle
      </v-icon>
      <v-btn :color="iconAndColor.color" variant="tonal" icon rounded size="small" readonly class="mr-2">
        <v-icon>{{ iconAndColor.icon }}</v-icon>
      </v-btn>
    </div>
    <div class="flex-grow-1">
      <b class="font-weight-bold"><user-avatar v-if="notif.created_by" :user="{ id: notif.created_by }" show-username class="mr-1"></user-avatar></b>
      <span v-if="date" class="ml-2 small text-medium-emphasis vcenter">{{ date }}</span>
      <div class="mb-2">{{ notif.message }}</div>
      <slot name="element"></slot>
    </div>
  </div>
</template>

<script>
  import useNotificationsStore from '@/stores/notifications';

  export default {
    props: {
      notif: { type: Object, required: true },
    },
    data() {
      return {
        notificationsStore: useNotificationsStore(),
      };
    },
    computed: {
      iconAndColor() {
        if (this.notif.field_type == 'comment') return { icon: 'far fa-comment', color: 'info' };
        if (this.notif.action == 'add') return { icon: 'fas fa-plus', color: 'successgreen' };
        if (this.notif.action == 'modify') return { icon: 'fas fa-edit', color: 'primary' };
        if (this.notif.action == 'check') return { icon: 'fas fa-check', color: 'successgreen' };
        if (this.notif.action == 'remove') return { icon: 'fas fa-trash', color: 'errorred' };
        if (this.notif.action == 'uncheck') return { icon: 'far fa-square', color: 'errorred' };
        return null;
      },
      date() {
        const dateOfCreation = moment(this.notif.date_of_creation);
        return (dateOfCreation.isSame(moment(), 'day')) ? dateOfCreation.fromNow() : `${this.$t('NOTIFICATIONS.DATE_TIME_SEPARATOR')} ${dateOfCreation.format('LT')}`;
      },
    },
    methods: {
      seenNotification(notif) { // mark as seen in the store
        this.notificationsStore.seen({ filters: { id: notif.id } });
      },
    },
  };
</script>
